import React, { useState } from "react";
import { useLocation } from "react-router";
import Navbar from "../components/admin/components/Navbar";
import Sidebar from "../components/admin/components/Sidebar";

const AdminLayout = ({ children }) => {
  const location = useLocation();
  const hideLayout = location.pathname === "/adminlogin";
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen flex bg-gradient-to-tr from-slate-50 via-slate-100/40 to-indigo-50/25 dark:from-[#0b0f19] dark:via-[#0e1322] dark:to-[#171e30] relative overflow-x-hidden">
      {!hideLayout && (
        <Sidebar mobileOpen={sidebarOpen} setMobileOpen={setSidebarOpen} />
      )}
      <div className="flex-1 flex flex-col min-w-0">
        {!hideLayout && (
          <Navbar onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
        )}
        <main className="flex-1">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
